module.exports = __webpack_public_path__ + "img/bottom.d0f118d7.png";